export default __webpack_public_path__ + "static/media/Vyre.81f2e56e.jpg";